import { FormControl, Grid, InputLabel, MenuItem, Select, TextField } from '@mui/material'
import { CompanyType } from '@planning/app/api'
import { CompanyAutocomplete } from '@planning/components/autocompletes/company-autocomplete/CompanyAutocomplete'
import { containerTypes } from '@planning/constants'
import { useTranslate } from '@tolgee/react'
import {
  CustomInputAdornment,
  useContainerAttributesParameters,
  useMinimalsTheme,
} from '@tom-ui/ui'
import { observer } from 'mobx-react-lite'
import { FC } from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import { UnitNumberController } from './UnitNumberController'

export const TrailerInfoForm: FC = observer(() => {
  const theme = useMinimalsTheme()
  const { t } = useTranslate()

  const { types: containerTypeParameters } = useContainerAttributesParameters()
  const { formState, control } = useFormContext()

  const { errors } = formState

  return (
    <>
      <Grid
        size={{
          sm: 6,
          xs: 12,
        }}
      >
        <UnitNumberController control={control} errors={errors} label={t('iluCode', 'ILU Code')} />
      </Grid>
      <Grid
        size={{
          sm: 6,
          xs: 12,
        }}
      >
        <Controller
          name='operator'
          control={control}
          render={({ field }) => (
            <CompanyAutocomplete
              required
              label={t('operator', 'Operator')}
              dataCy='operator-autocomplete'
              selectedCompanyShortName={field.value}
              handleOnChange={operator => {
                field.onChange(operator?.shortName)
              }}
              filterByTypes={[CompanyType.ShippingLine]}
              data-cy='container-operator-field'
            />
          )}
        />
      </Grid>
      <Grid
        size={{
          sm: 6,
          xs: 12,
        }}
      >
        <Controller
          name='length'
          control={control}
          render={({ field }) => (
            <TextField
              {...field}
              data-cy='container-length'
              label={`${t('length', 'Length')}`}
              fullWidth
              variant='outlined'
              type='text'
              name='length'
              error={!!errors.length}
              helperText={errors.length && t('fieldIsRequired', 'Field is required.')}
              InputProps={{
                endAdornment: (
                  <CustomInputAdornment
                    position='end'
                    color='secondary'
                    padding={theme.customSpacing.l}
                  >
                    ft
                  </CustomInputAdornment>
                ),
              }}
            />
          )}
        />
      </Grid>
      <Grid size={6}>
        <FormControl fullWidth>
          <InputLabel>{`${t('unitType', 'Unit Type')}`}</InputLabel>
          <Controller
            name='type'
            control={control}
            render={({ field }) => (
              <Select {...field} label={`${t('unitType', 'Unit Type')} *`} data-cy='container-type'>
                {containerTypes
                  ?.filter(d => containerTypeParameters[d.name]?.label)
                  .map(d => (
                    <MenuItem key={d.key} value={d.name}>
                      {containerTypeParameters[d.name].label}
                    </MenuItem>
                  ))}
              </Select>
            )}
          />
        </FormControl>
      </Grid>
      <Grid
        size={{
          sm: 12,
        }}
      >
        <Controller
          name='plateNumber'
          control={control}
          render={({ field }) => (
            <TextField
              {...field}
              data-cy='trailer-plate-no-field'
              label={`${t('plateNo', 'Plate no.')}`}
              fullWidth
              variant='outlined'
              type='text'
              name='plateNumber'
              error={!!errors.plateNumber}
            />
          )}
        />
      </Grid>
    </>
  )
})
